module.exports = __webpack_public_path__ + "static/media/desenvolvimentoPluginsWordpress.b853b70e.png";